/**
 * List application modes available
 */
export enum ApplicationModeEnum {
  Full = 'full',
  Embed = 'embed',
}
